<div [formGroup]="gs.gastroForm">
  <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">
    <div class="w50" style="height: 50px">
      <section class="m-box fulltext">
        <h2>Medical History</h2>
        <button class="t-btn-smart" *ngIf="!es.isClosed && ls.premissions?.Questionnaires" style="margin-bottom: 0.5em" [disabled]="aiSummaryLoading" (click)="getAiSummary()">
          {{ 'GUI.General.Buttons.Populate Smart History' | translate }}
          <span *ngIf="aiSummaryLoading" class="t-btn-smart-spinner"></span>
        </button>
        <textarea formControlName="MedicalHistory" class="scroller scroller-intro fulltext"
          style="min-height: 10em"></textarea>
        <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="
            atS.showAuto(
              gs.gastroForm?.get('MedicalHistory'),
              'Medical History',
              700
            )
          ">
          Auto Text
        </button>
      </section>
    </div>
    <div class="w50 summary-anamnesis" style="display: flex">
      <div class="summary-anamnesis"></div>
      <div class="w100 summary-recommendations" style="height: 100%; padding: 0">
        <section class="m-box fulltext" style="height: 100%">
          <h2>Purpose of Exam</h2>
          <textarea formControlName="ReasonExamination" class="scroller scroller-intro fulltext"
            style="min-height: 10em"></textarea>
          <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="
              atS.showAuto(
                gs.gastroForm?.get('ReasonExamination'),
                'Reason Examination',
                701
              )
            ">
            Auto Text
          </button>
        </section>
      </div>
    </div>
  </div>

  <!-- Neck Section (צוואר) -->
  <div class="l-flex-w t-boxMargin--spacebyPadding summary">
    <div class="w100">
      <section class="m-box fulltext" style="height: auto">
        <h2>Neck</h2>
        <textarea formControlName="NeckandSoftTissues" class="scroller fulltext" style="height: 6em"></textarea>
        <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="atS.showAuto(gs.gastroForm?.get('NeckandSoftTissues'), 'Neck', 20000)">
          Auto Text
        </button>
        <div class="l-flex-w t-boxMargin--spacebyPadding">
          <div class="w30">
            <section class="m-box">
              <h2>Thyroid</h2>
              <textarea formControlName="Thyroid" class="scroller scroller-intro fulltext"></textarea>
              <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="atS.showAuto(gs.gastroForm?.get('Thyroid'), 'Thyroid', 20016)">
                Auto Text
              </button>
            </section>
          </div>
          <div class="w30">
            <section class="m-box">
              <h2>Parotid</h2>
              <textarea formControlName="Parotid" class="scroller scroller-intro fulltext"></textarea>
              <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="atS.showAuto(gs.gastroForm?.get('Parotid'), 'Parotid', 20018)">
                Auto Text
              </button>
            </section>
          </div>
          <div class="w30">
            <section class="m-box">
              <h2>Salivary glands</h2>
              <textarea formControlName="SalivaryGlands" class="scroller scroller-intro fulltext"></textarea>
              <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="atS.showAuto(gs.gastroForm?.get('SalivaryGlands'), 'Salivary glands', 20017)">
                Auto Text
              </button>
            </section>
          </div>
          <div class="w30">
            <section class="m-box">
              <h2>Lymph nodes</h2>
              <textarea formControlName="LymphNodes" class="scroller scroller-intro fulltext"></textarea>
              <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="atS.showAuto(gs.gastroForm?.get('LymphNodes'), 'Lymph nodes', 20021)">
                Auto Text
              </button>
            </section>
          </div>
          <div class="w30">
            <section class="m-box">
              <h2>Blood vessels</h2>
              <textarea formControlName="BloodVessels" class="scroller scroller-intro fulltext"></textarea>
              <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="atS.showAuto(gs.gastroForm?.get('BloodVessels'), 'Blood vessels', 20022)">
                Auto Text
              </button>
            </section>
          </div>
        </div>
      </section>
    </div>
  </div>
  
  <app-gastro-summary [hideSignature]="true"></app-gastro-summary>

  <app-exam-diagnoses></app-exam-diagnoses>

  <div class="w100 summary">
    <section class="m-box">
      <h2>Summary of Exam</h2>
      <angular-editor formControlName="Summary" [config]="editorConfig" style="width: 100%"></angular-editor>
      <button class="t-btn-edit" *ngIf="! es.isClosed" (click)="atS.showAuto(gs.gastroForm.get('Summary'),'Summary',712, true, true)">Auto Text</button>
    </section>
  </div>

  <!-- =============== Exam Signature (Start) =============== -->
  <app-gastro-summary [signOnly]="true"></app-gastro-summary>
  <!-- =============== Exam Signature (End) =============== -->
</div>
